// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"21040dff","703":"5bb89dfe","787":"8fb70b7e"}[chunkId] + ".chunk.js";
};